import React from 'react';
import Publication from './Publication';
import usePublications from '../hooks/usePublications';
import useVideoContext from '../hooks/useVideoContext';
/*
 *  The object model for the Room object (found here: https://www.twilio.com/docs/video/migrating-1x-2x#object-model) shows
 *  that Participant objects have TrackPublications, and TrackPublication objects have Tracks.
 *
 *  The React components in this application follow the same pattern. This ParticipantTracks component renders Publications,
 *  and the Publication component renders Tracks.
 */

export default function ParticipantTracks(_ref) {
  var participant = _ref.participant,
      disableAudio = _ref.disableAudio,
      enableScreenShare = _ref.enableScreenShare,
      videoPriority = _ref.videoPriority;

  var _useVideoContext = useVideoContext(),
      room = _useVideoContext.room,
      gainCorrection = _useVideoContext.gainCorrection;

  var publications = usePublications(participant);
  var isLocal = participant === room.localParticipant;
  var filteredPublications;

  if (enableScreenShare && publications.some(function (p) {
    return p.trackName.includes('screen');
  })) {
    filteredPublications = publications.filter(function (p) {
      return !p.trackName.includes('camera');
    });
  } else {
    filteredPublications = publications.filter(function (p) {
      return !p.trackName.includes('screen');
    });
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, filteredPublications.map(function (publication) {
    return /*#__PURE__*/React.createElement(Publication, {
      key: publication.kind,
      publication: publication,
      participant: participant,
      isLocal: isLocal,
      disableAudio: disableAudio,
      videoPriority: videoPriority,
      gainCorrection: gainCorrection
    });
  }));
}